<template>
  <div>
    <a-spin size="large" :spinning="loading_detable" :indicator="indicator">
      <vxe-toolbar>
        <template #buttons>
          <vxe-input
            v-model="filterName_detable"
            type="search"
            placeholder="Input a key word"
            @keyup="searchEvent_detable"
          ></vxe-input>
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        show-overflow
        row-id="id"
        size="small"
        ref="xTable"
        :data="tableData_detable"
        align="center"
        header-align="center"
        class="my-sort"
        :column-config="{ isHover: true }"
        :sort-config="{
          showIcon: false,
          trigger: all,
        }"
        @header-cell-click="headerCellClickEvent"
      >
        <!-- <vxe-column type="seq" width="40"></vxe-column> -->
        <vxe-column field="author" title="Dataset ID" type="html">
          <!-- <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span>
          </template>
          <template #default="{ row }">
            <a
              @click="goSubpub(row.publinks)"
              target="_blank"
              style="color: blue"
              >{{ row.author }}</a
            >
          </template> -->
        </vxe-column>
        <vxe-column
          field="title"
          title="Article"
          type="html"
          show-header-overflow
          show-overflow
          width="60%"
        ></vxe-column>

        <!-- <vxe-column
          field="Treatment"
          title="Perturbation strategy"
          show-header-overflow
          type="html"
        ></vxe-column> -->
        <!-- <vxe-column field="cell" title="Cell type" type="html"></vxe-column> -->
        <!-- <vxe-column field="numberofcell" title="Cell count" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column> -->
        <!-- <vxe-column field="clusters" title="PC count" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
        <vxe-column field="num" title="Gene count" sortable>
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column>
        <vxe-column field="year" title="Year" sortable width="80">
          <template #header="{ column }">
            <span>{{ column.title }}</span>
            <span class="custom-sort" :class="{ 'is-order': column.order }">
              <i
                :class="[
                  column.order
                    ? `vxe-icon-sort-numeric-${column.order}`
                    : 'vxe-icon-sort',
                ]"
              ></i>
            </span> </template
        ></vxe-column> -->
        <vxe-column field="pubmed" title="Pubmed ID" type="html">
          <template #default="{ row }">
            <a
              type="button"
              class="downloadbutton"
              @click="goNCBI(row.pubmed)"
              target="_black"
              style="color: black; border-radius: 5px"
            >
              {{ row.pubmed }}
            </a>
          </template>
        </vxe-column>
        <vxe-column field="filesize" title="Size" type="html"></vxe-column>
        <vxe-column field="author" title="Seurat object" type="html">
          <template #default="{ row }">
            <a-icon
              :style="{ color: 'blue', fontSize: '20px' }"
              type="cloud-download"
              @click="downloadSeurat(row.author)"
            />
          </template>
        </vxe-column>
      </vxe-table>

      <vxe-pager
        background
        size="small"
        :loading="loading_detable"
        :current-page="tablePage_detable.currentPage"
        :page-size="tablePage_detable.pageSize"
        :total="tablePage_detable.totalResult"
        :page-sizes="[20, 50]"
        :layouts="[
          'PrevPage',
          'JumpNumber',
          'NextPage',
          // 'FullJump',
          'Sizes',
          'Total',
        ]"
        @page-change="handlePageChange_table"
      >
      </vxe-pager>
    </a-spin>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  data() {
    return {
      //相关性分析
      corModal: false,
      gene1: "",
      gene2: this.$route.query.gene,
      //加载
      spinning: true,
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      //全表搜索
      filterName_detable: "",
      tempdata_detable: [],
      //分页
      getdata_detable: null, //必须要生成这个data
      loading_detable: true,
      tableData_detable: [],
      tablePage_detable: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0,
      },
    };
  },
  created() {
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/download.php")
      .then((response) => {
        this.getdata_detable = response.data;
        this.findList_detable(this.getdata_detable);
        this.loading_detable = false;
      });
  },

  methods: {
    // 下载 rdata文件
    downloadSeurat(id) {
      // 创建一个隐藏的 <a> 元素
      var link = document.createElement("a");

      link.style.display = "none";

      // 设置文件的下载链接

      link.href =
        "http://research.gzsys.org.cn/perturbdb/data/publications/" +
        id +
        "/" +
        "PerturbDB_" +
        id +
        ".RDATA";

      link.setAttribute("download", "PerturbDB_" + id + ".RDATA");

      // 将 <a> 元素添加到文档中
      document.body.appendChild(link);

      // 模拟点击事件
      link.click();

      // 清理
      document.body.removeChild(link);
    },
    // 跳转
    goSubpub(value) {
      let routeData = this.$router.resolve({
        name: "pubdatasets",
        query: { datasetId: value },
      });
      window.open(routeData.href, "_blank");
    },
    goNCBI(value) {
      const href = "https://pubmed.ncbi.nlm.nih.gov/" + value;
      window.open(href);
    },
    // 排序
    headerCellClickEvent({
      column,
      triggerResizable,
      triggerSort,
      triggerFilter,
    }) {
      // 如果触发了列的其他功能按钮
      console.log(column["field"]);
      if (
        column.sortable &&
        !(triggerResizable || triggerSort || triggerFilter)
      ) {
        this.tcgaLoading = true;
        if (column.order === "desc") {
          axios
            .get("http://research.gzsys.org.cn/perturbdb/API/publications.php")
            .then((response) => {
              // 这个地方必须在searchEvent1函数之前, 而且在created函数里面, 两个数组都要赋值
              this.tableData = response.data;
              this.list1 = response.data;
            });
          this.$refs.xTable.clearSort();
          this.searchEvent1();
        } else if (column.order === "asc") {
          this.$refs.xTable.sort(column.property, "desc");
          var jiangxu = this.getdata_detable.sort(
            (a, b) => b[column.field] - a[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = jiangxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        } else {
          this.$refs.xTable.sort(column.property, "asc");
          //var field = column.field;
          var shengxu = this.getdata_detable.sort(
            (a, b) => a[column.field] - b[column.field]
          ); // 按照 num 属性降序排序
          this.getdata_detable = shengxu;
          this.findList_detable(this.getdata_detable);
          this.tcgaLoading = false;
        }
      }
    },
    formatAmount({ cellValue }) {
      return XEUtils.commafy(XEUtils.toNumber(cellValue));
    },
    // 页面切换和查询
    findList_detable(data) {
      this.loading_detable = true;
      setTimeout(() => {
        const list = data;
        this.loading_detable = false;
        this.tablePage_detable.totalResult = list.length;
        this.tableData_detable = list.slice(
          (this.tablePage_detable.currentPage - 1) *
            this.tablePage_detable.pageSize,
          this.tablePage_detable.currentPage * this.tablePage_detable.pageSize
        );
      }, 300);
    },
    handlePageChange_table({ currentPage, pageSize }) {
      this.tablePage_detable.currentPage = currentPage;
      this.tablePage_detable.pageSize = pageSize;
      if (this.tempdata_detable.length == 0) {
        this.findList_detable(this.getdata_detable);
      } else {
        this.findList_detable(this.tempdata_detable);
      }
    },
    searchEvent_detable() {
      this.tablePage_detable.currentPage = 1;
      const filterName = XEUtils.toValueString(this.filterName_detable)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["author", "title", "pubmed"];
        const rest = this.getdata_detable.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata_detable = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList_detable(this.tempdata_detable);
      } else {
        this.findList_detable(this.getdata_detable);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.my-sort .custom-sort {
  padding: 0 4px;
}
.my-sort .custom-sort.is-order {
  color: #409eff;
}
</style>
